import { Dialog } from 'primereact/dialog'
import React from 'react'
import { useLateArrival } from '../../Hooks/Features/Punctuality/useLateArrival'
import { convertTo12HourFormat } from '../../utils/Helper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const LateArrival = ({ popupOpne, setPopupOpen, selectedData, setSelectedData, GetEmployeeAttandance,currentUser }) => {
    const { reason, handleOnChange, words, handleSubmitReason, setReason, shiftTime } = useLateArrival({ setPopupOpen, selectedData, setSelectedData, GetEmployeeAttandance ,currentUser})

    return (
        <Dialog
            className='timesheet-dialog'
            modal={true}
            draggable={false}
            style={{ width: '50vw' }}
            visible={popupOpne}
            onHide={() => { setSelectedData({}); setPopupOpen(false); setReason("") }}
            header={() => {
                return (
                    <div style={{ color: "black" }}>
                        Late Arrival or Early Leave Reason
                    </div>
                );
            }}
        >
            <div className='row'>
                <div className='col-12'>
                    <div className='row'>
                    <div className='col-6'>
                        <p><b>Shift Time : </b> <FontAwesomeIcon icon="fa-solid fa-clock" />  {shiftTime?.shiftStartDate && convertTo12HourFormat(shiftTime?.shiftStartDate)} - {shiftTime?.shiftEndDate && convertTo12HourFormat(shiftTime?.shiftEndDate)}</p>
                        </div><div className='col-6'>
                        <p><b>Actual Time : </b> <FontAwesomeIcon icon="fa-solid fa-clock" />   {selectedData?.in_time && convertTo12HourFormat(selectedData?.in_time)} - {selectedData?.out_time && convertTo12HourFormat(selectedData?.out_time)} </p>
                    </div>
                    </div>
                    <div className='mt-3 mb-1'>
                        <p style={{ fontSize: "14px" }}>Enter Reason</p>
                        <textarea rows={5} value={reason} onChange={(e)=>handleOnChange(e.target.value)} placeholder='Write Reason' className='w-100 border' />
                        {
                            words.totalWords <= words.expectedWords && <p style={{ fontSize: "14px" }} className='mt-2'>{words.totalWords}/{words.expectedWords} words</p>
                        }
                    </div>
                    <div className="d-flex gap-2 justify-content-end">
                        <button className="btn-primary" onClick={() => handleSubmitReason()}>Submit</button>
                    </div>
                </div>
            </div>
        </Dialog>
    )
}

export default LateArrival